export default __webpack_public_path__ + "static/media/sample.edaae89f.xlsx";